import { Stage, CURRENT_STAGE } from 'src/contstant/apiEndpoints';

/**
 * Aliases allowed to open Audit Insights in PROD while the tab is in pilot.
 *
 * Stored lowercase so a differently-cased alias still matches after normalisation.
 */
const AUDIT_INSIGHTS_PILOT_ALIASES: ReadonlySet<string> = new Set([
  'clevemil',
  'hikahaya',
  'kasumono',
  'kukumpi',
  'mrypshah',
  'nbhakuni',
  'nicpears',
  'oggurram',
  'sailattu',
  'shpragy',
  'smokha',
  'ssdivya',
  'takumiii',
  'tjmoats',
  'uchiidek',
]);

/**
 * Whether this user gets Audit Insights in PROD ahead of the feature flag.
 *
 * PROD resolves flags from apiFlags alone — the shared lib drops local storage
 * overrides there — so a list is the only way to reach named users without turning
 * the tab on for everyone. Every other stage returns false and keeps whatever
 * FEATURE_FLAGS_BY_STAGE already says, which is how BETA and GAMMA stay unchanged.
 *
 * @param alias - Midway alias, empty before Midway resolves
 * @param stage - Deployment stage, defaults to the stage this bundle was built for
 * @returns true when the stage is PROD and the alias is on the pilot list
 */
export const isAuditInsightsPilotUser = (
  alias: string | null | undefined,
  stage: Stage = CURRENT_STAGE,
): boolean =>
  stage === Stage.PROD &&
  AUDIT_INSIGHTS_PILOT_ALIASES.has((alias ?? '').trim().toLowerCase());
